import TemplateClassic from "./TemplateClassic.jsx";
import TemplateModern from "./TemplateModern.jsx";

export const predefinedTemplates = {
  1: {
    template_id: "",
    name: "Template Clássico",
    image:
      "https://i.pinimg.com/564x/ea/04/b4/ea04b4e8cff84b23cafc87c73f4b1435.jpg",
    route: "templateClassic",
    color: "785b41",
    config: {
      logo: "https://lotemobile.com.br/templates/logo2.png",
      primaryColor: "0d1927",
      secondaryColor: "FFFFFF",
      sections: {
        menu: true,
        cabecalho: true,
        galeria: true,
        sobre: true,
        map: true,
        statusObra: true,
        loc: true, 
        formulario: true,
        rodape: true,
      },
      orderedsections: [
        "Menu",
        "Cabeçalho",
        "Sobre",
        "Map",
        "Galeria",
        "Status",
        "Loc",
        "Formulario",
        "Rodapé",
      ],

      navbar: {
        link_instagram: "inacio.sant_",
        Tel_Site: "(16) 98867-5073",
        nav_links: ["Inicio", "Sobre", "Galeria", "Contato"],
        colornav: "0d1b2a",
        colornavtext: "ffffff",
      },
      footer: {
        endereco: "Av. Paulo VI, 781 Franca - SP, 14403-138",
        telefone: "16 988675073",
        email: "suporte@ibsystem.com.br",
        facebook: "inaciosantana",
      },
      header: {
        imagemFundo:
          "https://novaharmonia.com.br/wp-content/uploads/2023/02/aerial-view-small-village-country-roadside-scaled.jpg",
        primaryColor: "0d1927",
        secondaryColor: "1a1a1a",
        nome: "BEM VINDO",
        descricao: "Um lugar para viver com qualidade e conforto.",
      },
      galeria: {
        carousel_upload: "",
        Tittle_carrossel: "Galeria",
        carouselImages: [
          "https://avt.com.br/wp-content/uploads/2023/08/terreno-em-area-urbana.jpg",
          "https://morada.ai/wp-content/uploads/2025/04/Untitled-297-x-210-mm-10.png",
          "https://avt.com.br/wp-content/uploads/2025/02/Terrenos-em-loteamentos-big.jpg",
          "https://images.pexels.com/photos/1250260/pexels-photo-1250260.jpeg?auto=compress&cs=tinysrgb&w=600",
        ],
      },
      statusObra: {
        progressValue: 0,
        progressColor: "00b5e1",
        titleColor: "ffffff",
        status_site: "",
        statusList: [
          {
            id: 1744317762433,
            status: "Agua",
            percentage: 60,
          },
          {
            id: 17443117762433,
            status: "Asfalto",
            percentage: 100,
          },
          {
            id: 1744317762433,
            status: "Energia",
            percentage: 90,
          },
          {
            id: 1744317762433,
            status: "Esgoto",
            percentage: 37,
          },
        ],
        currentStatus: "",
      },
      formulario: {
        tittle: "Entre em contato conosco",
        email: true,
        phone: true,
        name: true,
      },
      sobreNos: {
        localizacao: "Av. Paulo VI, 781  Franca - SP, 14403-138",
        sobre_empreendimento: "Descrição do empreendimento...",
      },
      monthly_value: 29.90,
      subscription_value: 299.90, 
    },
  },
  2: {
    name: "Template Moderno",
    image:
      "https://images.unsplash.com/photo-1688494930045-328d0f95efe9?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8bW9kZXJuJTIwYmFja2dyb3VuZHxlbnwwfHwwfHx8MA%3D%3D",
    route: "templateModern",
    color: "00b944",
    config: {
      logo: "https://lotemobile.com.br/templates/logomoderno1.png",
      primaryColor: "0d1927",
      secondaryColor: "174579",
      sections: {
        menu: true,
        cabecalho: true,
        galeria: true,
        sobre: true,
        statusObra: true,
        formulario: true,
        rodape: true,
      },
      orderedsections: [
        "Menu",
        "Cabeçalho",
        "Sobre",
        "Galeria",
        "Status",
        "Formulario",
        "Rodapé",
      ],
      navbar: {
        link_instagram: "empresa_moderno",
        Tel_Site: "(11) 98765-4321",
        nav_links: ["Início", "Sobre nós", "Galeria", "Contato"],
        colornav: "0d47a1",
        colornavtext: "ffffff",
      },
      footer: {
        endereco: "Av. Exemplo, 123 São Paulo - SP, 01000-000",
        telefone: "11 987654321",
        email: "contato@empresa.com.br",
        facebook: "empresa_moderno",
      },
      header: {
        imagemFundo:
          "https://novaharmonia.com.br/wp-content/uploads/2023/02/aerial-view-small-village-country-roadside-scaled.jpg",
        nome: "Nome do Empreendimento",
        descricao: "Descrição...",
        descricao1: "Descrição...",
        descricao2: "Descrição 3",
      },
      galeria: {
        carousel_upload: "",
        Tittle_carrossel: "Nossa galeria",
        carouselImages: [
          "https://avt.com.br/wp-content/uploads/2023/08/terreno-em-area-urbana.jpg",
          "https://morada.ai/wp-content/uploads/2025/04/Untitled-297-x-210-mm-10.png",
          "https://avt.com.br/wp-content/uploads/2025/02/Terrenos-em-loteamentos-big.jpg",
          "https://images.pexels.com/photos/1250260/pexels-photo-1250260.jpeg?auto=compress&cs=tinysrgb&w=600",
        ],
      },
      statusObra: {
        progressValue: 0,
        status_site: "",
        statusList: [
          {
            id: 1744317762433,
            status: "Agua",
            percentage: 60,
          },
          {
            id: 174433417762433,
            status: "Asfalto",
            percentage: 100,
          },
          {
            id: 1744317232433,
            status: "Energia",
            percentage: 90,
          },
        ],
        currentStatus: "",
      },
      formulario: {
        tittle: "Fale conosco",
        email: true,
        phone: true,
        cep: true,
        name: true,
      },
      sobreNos: {
        localizacao: "Av. Paulo VI, 781 Franca - SP, 14403-138",
        sobre_empreendimento:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce eget leo non urna volutpat. Sed euismod, nunc vel consectetur interdum, nisl nisi aliquet nunc, euismod aliquam nunc nisl euismod nunc. Donec vel ligula nec leo facilisis commodo. Nulla facilisi. Sed euismod, nunc vel consectetur interdum, nisl nisi aliquet nunc, euismod aliquam nunc nisl euismod nunc.",
      },
    },
  },
  3: {
    name: "Template Minimalista",
    image:
      "https://images.pexels.com/photos/911758/pexels-photo-911758.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    route: "templateMinimalista",
    color: "a99c44",
    config: {
      logo: "https://lotemobile.com.br/templates/logo2.png",
      primaryColor: "0d1927",
      secondaryColor: "FFFFFF",
      sections: {
        menu: true,
        cabecalho: true,
        galeria: true,
        sobre: true,
        statusObra: true,
        loc: true,
        formulario: true,
        rodape: true,
      },
      orderedsections: [
        "Menu",
        "Cabeçalho",
        "Sobre",
        "Map",
        "Galeria",
        "Status",
        "Loc",
        "Formulario",
        "Rodapé",
      ],

      navbar: {
        link_instagram: "inacio.sant_",
        Tel_Site: "(16) 98867-5073",
        nav_links: ["Inicio", "Sobre"],
        colornav: "0d1b2a",
        colornavtext: "ffffff",
      },
      footer: {
        endereco: "Av. Paulo VI, 781 Franca - SP, 14403-138",
        telefone: "16 988675073",
        email: "suporte@ibsystem.com.br",
        facebook: "inaciosantana"
        ,
      },
      header: {
        imagemFundo:
          "https://novaharmonia.com.br/wp-content/uploads/2023/02/aerial-view-small-village-country-roadside-scaled.jpg",
        primaryColor: "0d1927",
        secondaryColor: "1a1a1a",
        nome: "EMPREENDIMENTO ALTO PADRÃO",
        descricao: "Um lugar para viver com qualidade e conforto.",
      },
      galeria: {
        carousel_upload: "",
        Tittle_carrossel: "Galeria",
        carouselImages: [
          "https://avt.com.br/wp-content/uploads/2023/08/terreno-em-area-urbana.jpg",
          "https://morada.ai/wp-content/uploads/2025/04/Untitled-297-x-210-mm-10.png",
          "https://avt.com.br/wp-content/uploads/2025/02/Terrenos-em-loteamentos-big.jpg",
          "https://images.pexels.com/photos/1250260/pexels-photo-1250260.jpeg?auto=compress&cs=tinysrgb&w=600",
        ],
      },
      statusObra: {
        progressValue: 0,
        status_site: "",
        statusList: [
          {
            id: 1744317762433,
            status: "Agua",
            percentage: 60,
          },
          {
            id: 17443117762433,
            status: "Asfalto",
            percentage: 100,
          },
          {
            id: 1744317762433,
            status: "Energia",
            percentage: 90,
          },
          {
            id: 1744317762433,
            status: "Esgoto",
            percentage: 37,
          },
        ],
        currentStatus: "",
      },
      formulario: {
        tittle: "Entre em contato conosco",
        email: true,
        phone: true,
        cep: true,
        name: true,
      },
      loc: {
        tittle: "Entre em contato conosco",
        email: true,
        phone: true,
        cep: true,
        name: true,
      },
      sobreNos: {
        localizacao: "Av. Paulo VI, 781  Franca - SP, 14403-138",
        sobre_empreendimento: "Descrição do empreendimento...",
      },
      loc: {
        localizacao: "Av. Paulo VI, 781  Franca - SP, 14403-138",
      },
    },
  },
};
